import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    className?: string;
    count: number;
    dataTestId: string;
}

export const FavouritesCountBadge = (props: IProps) => {
    const {className, count, dataTestId} = props;

    return (
        <span aria-hidden="true">
            <Text as="span" className={cx(badgeStyle, className)} color="var(--colors-white)" dataTestId={dataTestId} preserveFontSize variant="info_txt_2">
                {count}
            </Text>
        </span>
    );
};

const badgeStyle = css({
    position: "absolute",
    top: 0,
    left: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "1.6rem",
    h: "1.6rem",
    bg: "var(--colors-danger)",
    borderRadius: "50%",
    pointerEvents: "none"
});
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    className?: string;
    count: number;
    dataTestId: string;
}

export const FavouritesCountBadge = (props: IProps) => {
    const {className, count, dataTestId} = props;

    return (
        <span aria-hidden="true">
            <Text as="span" className={cx(badgeStyle, className)} color="var(--colors-white)" dataTestId={dataTestId} preserveFontSize variant="info_txt_2">
                {count}
            </Text>
        </span>
    );
};

const badgeStyle = css({
    position: "absolute",
    top: 0,
    left: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "1.6rem",
    h: "1.6rem",
    bg: "var(--colors-danger)",
    borderRadius: "50%",
    pointerEvents: "none"
});
